<template>
	<div class="card-wrap pb-9 pt-8 px-3 px-sm-7">
		<h1 class="card--title text-center mb-1">
			{{ $t('easy-to-start.card3.title') }}
		</h1>
		<h1
			class="card--text text-center mb-5 mb-sm-5"
			v-html="$t('easy-to-start.card3.sub-title')"
		></h1>

		<div
			class="mb-5"
			:class="{ ' mb-sm-6': language === 'ko', ' mb-sm-5': language === 'ja' }"
		>
			<div
				class="process-title mb-3"
				v-html="$t('easy-to-start.card3.process-title-1')"
			></div>
			<div class="d-flex align-center mb-1" style="position: relative">
				<div class="process">
					{{ $t('easy-to-start.card3.process-1') }}
				</div>
				<div class="process">
					{{ $t('easy-to-start.card3.process-2') }}
				</div>
				<div class="process">
					{{ $t('easy-to-start.card3.process-3') }}
				</div>
				<div
					class="line"
					:style="language === 'ja' ? 'margin-top:10px' : ''"
					style="max-width: 85%"
				></div>
			</div>
			<div class="d-flex align-center" style="position: relative">
				<v-spacer></v-spacer>
				<div class="process">
					{{ $t('easy-to-start.card3.process-4') }}
				</div>
				<div class="process">
					{{ $t('easy-to-start.card3.process-4') }}
				</div>
				<v-spacer></v-spacer>
				<div class="line" style="max-width: 33%; left: 33%"></div>
			</div>
		</div>
		<div
			class="process-title"
			:class="{ 'mb-7': language === 'ko', 'mb-5': language === 'ja' }"
			v-html="$t('easy-to-start.card3.process-title-2')"
		></div>
		<v-row no-gutters>
			<v-col cols="4">
				<div class="process-card pt-6">
					<img
						class="process-card-img"
						src="@/assets/images/process-1-icon.png"
						alt=""
					/>
					{{ $t('easy-to-start.card3.process-point1') }}
				</div>
			</v-col>
			<v-col cols="4">
				<div class="process-card pt-5">
					<img
						class="process-card-img"
						src="@/assets/images/process-2-icon.png"
						alt=""
					/>
					<span v-html="$t('easy-to-start.card3.process-point2')"></span>
				</div>
			</v-col>
			<v-col cols="4">
				<div class="process-card pt-6">
					<img
						class="process-card-img"
						src="@/assets/images/process-3-icon.png"
						alt=""
					/>
					{{ $t('easy-to-start.card3.process-point3') }}
				</div>
			</v-col>
		</v-row>
	</div>
</template>

<script>
export default {
	computed: {
		language() {
			return this.$store.getters['language']
		},
	},
}
</script>

<style lang="scss" scoped>
.card-wrap {
	border-radius: 20px;
	box-shadow: 0 11px 33px 0 rgba(33, 51, 82, 0.1);
	background-color: #fff;
}
.card--title {
	font-size: 22px;
	font-weight: bold;
	color: #1a1a1a;
}
@media screen and (max-width: 600px) {
	.card--title {
		font-size: 20px;
	}
}
.card--text {
	font-size: 16px;
	letter-spacing: -0.8px;
	color: #1a1a1a;
	font-weight: normal;
}
@media screen and (max-width: 600px) {
	.card--text {
		font-size: 14px;
	}
}

.process-title {
	font-size: 15px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: -0.47px;
	text-align: center;
	color: #1a1a1a;
}
@media screen and (max-width: 600px) {
	.process-title {
		font-size: 12px;
		letter-spacing: -0.38px;
	}
}

.process {
	width: 105px;
	padding: 10px;
	border-radius: 18.7px;
	border: solid 1.1px #dfdfdf;
	background-color: #fff;
	font-size: 12.1px;
	font-weight: 500;
	letter-spacing: -0.61px;
	text-align: center;
	color: #1a1a1a;
	z-index: 2;
	margin: 0 2.5px;
}
@media screen and (max-width: 600px) {
	.process {
		font-size: 11px;
	}
}
.line {
	position: absolute;
	width: 100%;
	top: 20px;
	background-color: #dfdfdf;
	height: 1px;
	z-index: 1;
}

.process-card {
	margin: 0 5px;
	height: 66px;
	border-radius: 11px;
	box-shadow: 0 2px 11px 0 rgba(33, 51, 82, 0.15);
	background-color: #fff;
	position: relative;
	font-size: 12.1px;
	font-weight: 500;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.27;
	letter-spacing: -0.61px;
	text-align: center;
	color: #1a1a1a;

	.process-card-img {
		position: absolute;
		top: -18px;
		left: 50%;
		margin-left: -18px;
	}
}
</style>
